import { docSearchApi } from '~/api/def/servers/defaultServer';

export const docCompareEndpoint = {
  server: docSearchApi,
  path: 'doc-compare',
  description: '',
};

// Chunk finder

// chat
